import React from 'react';
import Icon from 'components/AppIcon';


const TrustElements = ({ currentLanguage }) => {
  const content = {
    es: {
      title: "¿Por qué elegir BAC Pool CR?",
      subtitle: "Más de 5 años de experiencia sirviendo a Costa Rica",
      mapTitle: "Área de Cobertura",
      mapSubtitle: "Servimos en toda la Gran Área Metropolitana"
    },
    en: {
      title: "Why choose BAC Pool CR?",
      subtitle: "Over 5 years of experience serving Costa Rica",
      mapTitle: "Coverage Area",
      mapSubtitle: "We serve throughout the Greater Metropolitan Area"
    }
  };

  const certifications = [
    {
      icon: "Award",
      titleEs: "Técnicos Certificados",
      titleEn: "Certified Technicians",
      descriptionEs: "Personal capacitado y certificado en mantenimiento de piscinas",
      descriptionEn: "Trained and certified staff in pool maintenance"
    },
    {
      icon: "Shield",
      titleEs: "Empresa Registrada",
      titleEn: "Registered Company",
      descriptionEs: "Cédula jurídica 3-101-123456 registrada en Costa Rica",
      descriptionEn: "Legal entity 3-101-123456 registered in Costa Rica"
    },
    {
      icon: "Clock",
      titleEs: "Puntualidad Garantizada",
      titleEn: "Guaranteed Punctuality",
      descriptionEs: "Cumplimos con los horarios acordados o te devolvemos el dinero",
      descriptionEn: "We meet agreed schedules or your money back"
    },
    {
      icon: "Leaf",
      titleEs: "Productos Eco-Friendly",
      titleEn: "Eco-Friendly Products",
      descriptionEs: "Utilizamos químicos seguros para el ambiente y tu familia",
      descriptionEn: "We use chemicals safe for the environment and your family"
    }
  ];

  const stats = [
    { number: "500+", labelEs: "Piscinas Atendidas", labelEn: "Pools Serviced" },
    { number: "98%", labelEs: "Satisfacción Cliente", labelEn: "Customer Satisfaction" },
    { number: "5+", labelEs: "Años Experiencia", labelEn: "Years Experience" },
    { number: "24/7", labelEs: "Soporte Disponible", labelEn: "Support Available" }
  ];

  const text = content[currentLanguage];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-4">
            {text.title}
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            {text.subtitle}
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-primary mb-2">
                {stat.number}
              </div>
              <div className="text-text-secondary font-medium">
                {currentLanguage === 'es' ? stat.labelEs : stat.labelEn}
              </div>
            </div>
          ))}
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {certifications.map((cert, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={cert.icon} size={32} className="text-primary" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">
                {currentLanguage === 'es' ? cert.titleEs : cert.titleEn}
              </h3>
              <p className="text-text-secondary text-sm">
                {currentLanguage === 'es' ? cert.descriptionEs : cert.descriptionEn}
              </p>
            </div>
          ))}
        </div>

        {/* Service Area Map */}
        <div className="bg-surface rounded-lg p-8 shadow-subtle">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-heading font-bold text-text-primary mb-2">
              {text.mapTitle}
            </h3>
            <p className="text-text-secondary">
              {text.mapSubtitle}
            </p>
          </div>
          
          <div className="aspect-video rounded-lg overflow-hidden">
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title="BAC Pool CR Service Area"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=9.9281,-84.0907&z=10&output=embed"
              className="border-0"
            ></iframe>
          </div>
          
          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            {['San José', 'Cartago', 'Alajuela', 'Heredia'].map((city, index) => (
              <div key={index} className="flex items-center justify-center space-x-2 text-sm text-text-secondary">
                <Icon name="MapPin" size={16} className="text-primary" />
                <span>{city}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustElements;